import React from "react";
import { Redirect, Link } from "react-router-dom";
import { loadImage, logoImage } from "../../../../assets";

export default function Headers() {
  return (
    <div className="main-bg">
      <header className="direct-link-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-8">
              <div className="right-company-logo">
                <img
                  id="direct-link-logo"
                  style={{ width: 40 }}
                  className="direct-link-logo-class"
                  src={loadImage}
                  alt="Loading"
                  title="Loading"
                />

                <span
                  className="direct-link-company-name"
                  id="direct-link-title"
                ></span>
              </div>
            </div>
            <div className="col-4 text-right align-self-md-center">
              <span className="powered-by"> POWERED BY</span>
              <span className="left-evom-logo">
                <Link to="/dashboard">
                  <img src={logoImage} height="48px" alt="LA Moving Star" title="LA Moving Star" />
                </Link>
              </span>
            </div>

            {/* <div className="col-6 text-right">
              <div className="header-icons-wrapper">
                {localStorage.getItem("token") && (
                  <div className="help pointer-point">Help</div>
                )}
              </div>
            </div> */}
          </div>
        </div>
      </header>
    </div>
  );
}
